import React, { useCallback, useMemo } from 'react';
import * as Mui from '@mui/material';
import { CheckboxField } from '@/types/form';
import { RenderFieldProps } from "@/types/form";

const Checkbox = ({ field, value, id, onChange }: RenderFieldProps) => {
  // Helper functions to escape and unescape commas
  const escapeComma = (str: string) => str.replace(/,/g, '\\,');
  const unescapeComma = (str: string) => str.replace(/\\,/g, ',');

  const selectedValues = useMemo(() => {
    if (!value) return [];
    return value.split(/(?<!\\),/).map(unescapeComma);
  }, [value]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const option = e.target.value;
      const newSelectedValues = e.target.checked
        ? [...selectedValues, option]
        : selectedValues.filter((v) => v !== option);
      onChange(id, newSelectedValues.map(escapeComma).join(','));
    },
    [id, onChange, selectedValues]
  );

  return (
    <Mui.FormControl component="fieldset" fullWidth margin="normal">
      <Mui.FormLabel component="legend">{field.label}</Mui.FormLabel>
      <Mui.FormGroup sx={{ flexDirection: 'column' }}>
        {(field as CheckboxField).options?.map((option) => (
          <Mui.FormControlLabel
            key={option}
            control={
              <Mui.Checkbox
                checked={selectedValues.includes(option)}
                onChange={handleChange}
                value={option}
              />
            }
            label={option}
          />
        ))}
      </Mui.FormGroup>
    </Mui.FormControl>
  );
};

export default React.memo(Checkbox);